import Routes from "router/routes";

export default function KroFooter() {
  // const location = useLocation();
  //
  // const hiddenRoutes = ["enter-amount", "payment-summary"];
  //
  //
  // const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // const shouldHideFooter =
  //   isMobile && hiddenRoutes.some((route) => location.pathname.includes(route));

  return (
    <footer className={`mx-auto max-w-[1440px] px-2 pb-8 pt-20`}>
      <div
        className={`flex flex-col items-center gap-6 lg:flex-row lg:items-center lg:justify-between`}
      >
        <LogoSection />
        <NavLinks />
      </div>
    </footer>
  );
}
const LogoSection = () => (
  <div className="flex flex-col items-center justify-center lg:items-start lg:text-left">
    <div className="flex flex-row items-center justify-center gap-2 lg:justify-start">
      <img
        src="/assets/icons/giv_logo.svg"
        alt="Giv Logo"
        className="h-[30px] w-[48.24px]"
      />
      <p className="leading-6 text-body-lg font-[400] tracking-[-0.005em] text-neutral-900">
        Powered by
      </p>
      <a
        href="https://www.krotrust.com"
        className="hover:underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/images/SmallKroLogo.svg"
          alt="Kro Logo"
          className="h-[30px] w-[48.24px]"
        />
      </a>
    </div>
  </div>
);

const NavLinks = () => (
  <div className="flex flex-row items-center justify-center gap-6 lg:justify-end">
    <ul className="flex flex-row items-center space-x-6 text-body-md leading-[24px] tracking-[-0.005em] text-[#022928]">
      {/*<li className="flex items-center">*/}
      {/*  <a href="/campaigns" className="hover:underline">*/}
      {/*    Campaigns*/}
      {/*  </a>*/}
      {/*</li>*/}
      {/*<div className="h-[24px] border-l border-green-500"></div>*/}
      <li className="flex items-center">
        <a
          href={Routes.ABOUT}
          className="hover:underline"
          target="blank"
          rel="noopener noreferrer"
        >
          About
        </a>
      </li>
      <div className="h-[24px] border-l border-green-500"></div>
      <li className="flex items-center">
        <a
          href="https://separate-soup-1a5.notion.site/Terms-and-Conditions-145278ebc2bb8049ae26e92d9fd7435d?pvs=4"
          className="hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </a>
      </li>
      <div className="h-[24px] border-l border-green-500"></div>
      <li className="flex items-center">
        <a
          href="https://separate-soup-1a5.notion.site/Privacy-Policy-145278ebc2bb80fdb2cdc16843e10edb?pvs=4"
          className="hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
      </li>
    </ul>
  </div>
);
